import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Divider, Paper, TableRow, Typography } from "@mui/material";
import MuiTableCell from "@material-ui/core/TableCell";
import { ClassicTable } from "../../../utils/components/Styles";
import { MAX_COLS, BASE_URL } from "../../../global";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";
import moment from "moment";
import { UNCERTAINTY_LINK } from "../../master/staticTable/editTable";

const BlackBorderTableCell = withStyles({
  root: {
    border: "1px solid black !important",
    borderBottomWidth: "0px !important",
    padding: "0px",
    margin: "0px",
    lineHeight: "1.32",
    fontSize: "12px",
    paddingLeft: "5px",
  },
})(MuiTableCell);

const groupByVersion = (rows) => {
  const versionMap = {};

  rows.forEach((r) => {
    const version = r[r.length - 1]; // last value
    if (!versionMap[version]) versionMap[version] = [];
    versionMap[version].push(r);
  });

  return versionMap;
};

export default function RenderAuditStaticTables({
  tableDisplayStatus,
  certificateId,
  instrumentId,
  deletedTableIds,
  tableDivide,
  DUCID
}) {
  const [staticReadingRows, setStaticReadingRows] = React.useState([]);
  const [selectedRangeIds, setSelectedRangeIds] = React.useState([]);
  const [staticCertificateReadings, setStaticCertificateReadings] =
    React.useState([]);
  const [tables, setTables] = React.useState(null);
  const [tableName, setTableName] = React.useState("");
  const [unitName, setUnitName] = React.useState("");
  const [staticTables, setStaticTables] = React.useState([]);
  const [versionGroups, setVersionGroups] = React.useState([]);
    const [derivedColumns, setDerivedColumns] = React.useState([]);
    const [tableConfig, setTableConfig] = React.useState({});


  function fetchCertificateStaticTables(instrumentId, deletedTableIds) {
    deletedTableIds = deletedTableIds?.split(",")?.map((id) => Number(id));
    axiosWithToken
      .get(
        BASE_URL +
          `datasheetStaticTables?_where=(instrumentId,eq,${instrumentId})`
      )
      .then((res) => {
        if (deletedTableIds) {
          res.data = res.data.filter(
            (row) => !deletedTableIds.includes(row.id)
          );
        }
         let tmp = {};
        let cMap = {};
        res.data.map((table) => {
          tmp[table.id] = {
            isUncertainty: table.isUncertainty,
            isVerticalUncertainty: table.isVerticalUncertainty,
            isAutomated: table.isAutomated,
            defaultValues: JSON.parse(table.defaultConfiguration)?.values,
          };
          cMap[table.id] = Object.keys(
            JSON.parse(table.defaultConfiguration).formulas,
          );
        });


        res.data = res.data.map((table) => {
          return {
            ...table,
            defaultConfiguration: JSON.parse(
              table?.defaultConfiguration || null
            ),
          };
        });

        setDerivedColumns({ ...cMap });
        setTableConfig(tmp);
        setStaticTables(res.data);
      })
      .catch((err) => {
        console.log("datasheet static tables data fetching error: ", err);
      });
  }

  function fetchStaticReadingRows() {
    let url = BASE_URL;
    let SQLQuery ={query:`SELECT d.*, u.userName FROM datasheetReadingsAudit d LEFT JOIN users u ON d.createdBy = u.id WHERE d.datasheetId = ${certificateId}`}
    axiosWithToken
      .post(
        url + `dynamic`,
        SQLQuery
      )
      .then((res) => {
        setStaticCertificateReadings(res.data);
      })
      .catch((err) => {
        console.log("static certificate tables data fetching error: ", err);
      });
  }

  const renderCommonHeader = (defaultConfiguration) => {

    if (!defaultConfiguration) return null;
    let hasCommonHeader = defaultConfiguration?.hasCommonHeader;
    if (hasCommonHeader) {
      let commonHeaderConfig =
        defaultConfiguration.commonHeaderConfig?.split(",");
      let cols = [];
      commonHeaderConfig?.forEach((col) => {
        let [name, size] = col?.split(":");
        cols.push(
          <BlackBorderTableCell
            style={{ textAlign: "center" }}
            colSpan={Number(size)}
            className={`${name != "$" ? "common-border" : ""}`}
          >
            <b>{name != "$" ? name : ""}</b>
          </BlackBorderTableCell>
        );
      });

      return <TableRow>{cols}</TableRow>;
    }
    return null;
  };

  const getTotalUnitRows = (staticReadingRows, tableId) => {
    let count = 0;
    count = staticReadingRows
      ?.filter((e) => e[0] == tableId)
      ?.some((row) => {
        if (row[2]?.includes("_unit_")) count += 1;
        if (count > 1) return true;
      });
    if (count) count = 2;
    else count = 0;
    return count;
  };

  const renderTableCell = (
    table,
    row,
    rowIndex,
    cell,
    cellIndex,
    current_row_units = null,
    prevRows = []
  ) => {
    let field = null;
    const previousRow = prevRows?.[rowIndex];
    const prevCell = previousRow?.[cellIndex + 2] ?? null;
    // check if value changed
    const isChanged = cell !== prevCell;

    if (String(cell)?.includes("_unit_")) {
      // if (table["c" + (cellIndex + 1)]?.toLowerCase()?.match(/m+\d+/g)) {
      //   field = <div></div>;
      // } else {
      let unit = cell.split("_unit_")[1];
      field = (
        <span>
          <b>{unit}</b>
        </span>
      );
      // }
    } else if (cell && cell[0] == "$") {
      field = (
        <span>
          {!isNaN(cell.slice(1))
            ? cell.slice(1)?.replaceAll("#", " ")
            : cell.slice(1)?.replaceAll("#", " ")}
        </span>
      );
    } else if (cell && cell == "null") {
      field = (
        <span>
          {!isNaN(cell.slice(1))
            ? Number(cell.slice(1)).toFixed(2)?.replaceAll("#", " ")
            : ""}
        </span>
      );
    } else {
      let unit = current_row_units?.[cellIndex + 2]?.split("_unit_")[1];
      if (unit?.length > 0) unit = " " + unit;
      else unit = "";
      field = (
        <span>
          {row[cellIndex + 2]?.split("#")?.[0]}
          {unit}
        </span>
      );
    }
    return (
      <td
        key={cellIndex}
        // className="tableCss"
        className={`tableCss ${isChanged ? "changedCell" : ""}`}
        style={{
          textAlign: "center",
        }}
      >
        {field}
      </td>
    );
  };

  const getTableIndex = (tableId, isStatic = false) => {
    if (!isStatic) {
      for (let i = 0; i < tables.length; i++) {
        if (tables[i]["id"] == tableId) {
          return i;
        }
      }
    } else {
      for (let i = 0; i < staticTables.length; i++) {
        if (staticTables[i]["id"] == tableId) {
          return i;
        }
      }
    }
    return -1;
  };

 const initiateStaticReadingRows = () => {
  if (!staticCertificateReadings || !staticTables) return null;

  const tempStaticCertReadings = [...staticCertificateReadings];
  const tableMap = Object.fromEntries(staticTables.map((t) => [t.id, t]));
  const rowUnitMap = {};
  let CurrentUnitRow = -1;

  const updatedDatasheetStaticReadings = tempStaticCertReadings.map((reading, index) => {
    // Track unit rows
    if (!rowUnitMap[reading.tableId]) rowUnitMap[reading.tableId] = {};

    if (reading.c1?.includes("_unit_")) {
      CurrentUnitRow = [reading.id, reading.uncertainty];
    } else {
      rowUnitMap[reading.tableId][reading.id] = CurrentUnitRow;
    }

    // Process c1–cN
    for (let i = 1; i <= MAX_COLS; i++) {
      const key = `c${i}`;
      let value = reading[key];

      if (value == null) break;

      if (!value.includes("_unit_") && !value.includes("_rh_")) {
        if (value !== "NA") {
          const isDerived =
            derivedColumns[reading.tableId]?.includes(key) ||
            tableMap[reading.tableId]?.[key]?.includes(UNCERTAINTY_LINK);

          value = value.replaceAll("$", "");
          value = (isDerived ? "$" : "") + value.split("#")[0];
        }
      }

      reading[key] = value;
    }

    // Remove null columns
    Object.keys(reading).forEach((key) => {
      if (/^c\d+$/.test(key) && reading[key] === null) delete reading[key];
    });

    // Fix uncertainty field
    if (
      reading.uncertainty &&
      !reading.uncertainty.includes("_unit_") &&
      !reading.uncertainty.includes("_rh_")
    ) {
      reading.uncertainty = ("$" + reading.uncertainty.split("#")[0]).replace(/\$+/g, "$");
    }

    // Set selected ranges
    selectedRangeIds[index] = reading.standardRanges;

    return reading;
  });

  // Build c1–cN row array
const allCValues = updatedDatasheetStaticReadings.map((obj, index) => {
   const tableIndex = staticTables.findIndex((t) => t.id === obj.tableId);
  const table = staticTables[tableIndex];
  
  // 1️⃣ find max cN key available in object
  const cKeys = Object.keys(obj).filter(k => /^c\d+$/.test(k));
  const maxCIndex = cKeys.length
    ? Math.max(...cKeys.map(k => Number(k.slice(1))))
    : 0;

  // 2️⃣ build c-values array with missing keys filled as ""
  const cValues = [];
  for (let i = 1; i <= maxCIndex; i++) {
    const key = `c${i}`;
    const value = obj[key];

    cValues.push(
      value !== null && value !== undefined ? value : ""
    );
  }

  // 3️⃣ add uncertainty BEFORE userName
  let uncertaintyValue = null;
  if (table?.isUncertainty == 1 && !table?.isVerticalUncertainty) {
    uncertaintyValue = obj.uncertainty?.replaceAll("~", "") ?? "null";
  }

  // 4️⃣ final output row
  const values = [
    obj.tableId,
    obj.datasheetId,
    ...cValues,
    ...(uncertaintyValue !== null ? [uncertaintyValue] : []), // add before userName
    obj.userName,
    obj.lastModified,
    obj.version,
  ];

  return values;
});



  setStaticReadingRows(allCValues);
};


  const renderRows = (table, staticReadingRows, prevRows) => {
    let i = 1;
    let currentUnitRow = [];

    let totalUnitRows = getTotalUnitRows(staticReadingRows, table.id);

    return [
      ...staticReadingRows?.map((row, rowIndex) => {
        if (row[0] == table.id) {
          if (row[2]?.includes("_rh_")) {
            i = 1;
            return (
              <tr
                key={rowIndex}
                height="14px"
                style={{
                  pageBreakInside: "avoid",
                  pageBreakAfter: "avoid",
                  pageBreakBefore: "avoid",
                }}
              >
                <td
                  className="tableCss"
                  colSpan={row.length - 2}
                  style={{ textAlign: "center", fontWeight: "400" }}
                >
                  {row[0 + 2].split("_rh_")[1]?.replaceAll("#", " ")}
                </td>
              </tr>
            );
          } else if (row[2]?.includes("_unit_")) {
            currentUnitRow = row;
            if (totalUnitRows < 2) {
              return (
                <tr
                  key={rowIndex}
                  height="14px"
                  style={{
                    pageBreakInside: "avoid",
                    pageBreakAfter: "avoid",
                    pageBreakBefore: "avoid",
                  }}
                >
                  {row
                    .slice(2, row.length) // 2: tableId + datasheetId
                    .map((cell, cellIndex) =>
                      renderTableCell(
                        table,
                        row,
                        rowIndex,
                        cell,
                        cellIndex,
                        null,
                        prevRows
                      )
                    )}
                </tr>
              );
            } else return null;
          }
          // else normal row
          return (
            <tr
              key={rowIndex}
              height="14px"
              id="pagbreaksborder"
              style={{
                pageBreakInside: "avoid",
                pageBreakAfter: "avoid",
                pageBreakBefore: "avoid",
              }}
            >
              {row
                .slice(2, row.length) // 2: tableId + datasheetId
                .map((cell, cellIndex) => {
                  if (totalUnitRows > 1)
                    return renderTableCell(
                      table,
                      row,
                      rowIndex,
                      cell,
                      cellIndex,
                      currentUnitRow,
                      prevRows
                    );
                  else
                    return renderTableCell(
                      table,
                      row,
                      rowIndex,
                      cell,
                      cellIndex,
                      null,
                      prevRows
                    );
                })}
            </tr>
          );
        }
      }),
    ].concat(
      table.isUncertainty == 1 &&
        table.isVerticalUncertainty == 1 &&
        staticReadingRows &&
        staticReadingRows.length > 0
        ? [
            <tr
              key={staticReadingRows.length}
              height="14px"
              id="pagbreaksborder"
              style={{
                pageBreakInside: "avoid",
                pageBreakAfter: "avoid",
                pageBreakBefore: "avoid",
              }}
            >
              <td
                className="tableCss text-align-left"
                colSpan={staticReadingRows[0].length - 2 + 1}
                style={{ fontWeight: "400" }}
              >
                <b>Expanded Uncertainty ± : </b>
                {staticCertificateReadings.reduce(
                  (a, b) =>
                    Math.max(
                      parseFloat(a.uncertainty) ? parseFloat(a.uncertainty) : 0,
                      parseFloat(b.uncertainty) ? parseFloat(b.uncertainty) : 0
                    ),
                  -Infinity
                )}
              </td>
            </tr>,
          ]
        : []
    );
  };

 React.useEffect(() => {
  if (!staticReadingRows?.length) return;

  const grouped = groupByVersion(staticReadingRows);
  const versions = Object.entries(grouped);

  let prevRows = [];
  const finalGroups = versions.map(([version, rows]) => {

    // 👉 Extract cleaned rows (remove last two values)
    const cleanedRows = rows.map((r) => r.slice(0, -3));

    // 👉 Extract lastModified (second last value)
    const lastModified = rows[0][rows[0].length - 2];

    const useName = rows[0][rows[0].length - 3];

    const group = {
      version,
      cleanedRows,
      prevRows,
      lastModified,
      DUCID,
      useName,
    };

    prevRows = cleanedRows; // update for next version

    return group;
  });

  setVersionGroups(finalGroups);
}, [staticReadingRows]);


  React.useEffect(() => {
    initiateStaticReadingRows();
  }, [staticCertificateReadings, staticTables, certificateId]);

  React.useEffect(() => {
    fetchStaticReadingRows();
  }, [certificateId]);

  React.useEffect(() => {
    fetchCertificateStaticTables(instrumentId, deletedTableIds);
  }, [instrumentId, deletedTableIds, certificateId]);

  if (!staticTables) return null;

  let validTables = staticTables
    ?.filter((table) => table.status == 1)
    ?.map((table, tableIndex) => {
      if (tableDisplayStatus === 1 && table.isAutomated !== 0) return null;
      else if (tableDisplayStatus === 2 && table.isAutomated !== 1) return null;

      return table;
    })
    ?.filter((t) => t !== null);

  let split1 = 0;
  let second = false;
  return validTables.map((table, tableIndex) => {
    let i = 0;

    let resd = tableIndex % 2;

    let col = second ? 6 : 12;
    if (second) second = false;
    else if (resd === split1) {
      if (tableIndex !== validTables.length - 1) {
        let len =
          Array.from({ length: MAX_COLS + 1 }, (_, i) => {
            if (validTables[tableIndex]["c" + i] != null) {
              return true;
            }
          }).filter((e) => e === true).length +
          (tableDivide ? 0 : 1) +
          (validTables[tableIndex]["isUncertainty"] == 1 ? 1 : 0) +
          (validTables[tableIndex]["isComplianceStatus"] == 1 ? 1 : 0) +
          Array.from({ length: MAX_COLS + 1 }, (_, i) => {
            if (validTables[tableIndex + 1]["c" + i] != null) {
              return true;
            }
          }).filter((e) => e === true).length +
          (tableDivide ? 0 : 1) +
          (validTables[tableIndex + 1]["isUncertainty"] == 1 ? 1 : 0) +
          (validTables[tableIndex + 1]["isComplianceStatus"] == 1 ? 1 : 0);

        if (len < (tableDivide ? 9 : 6)) {
          second = true;
          col = 6;
        } else {
          split1 += 1;
          split1 %= 2;
        }
      }
    }

    let showHeader = table?.defaultConfiguration?.showHeader;
    showHeader = showHeader === undefined ? true : showHeader;

    return (
      <div
        key={tableIndex}
        align="left"
        style={{
          marginBottom: "3px",
          pageBreakInside:
            (tableIndex === 0 && (col === 6 || col === 12)) ||
            (tableIndex === 1 && col === 6) ||
            (tableIndex < 1 && col === 6)
              ? "auto"
              : "avoid",
        }}
        className={col === 6 ? "col-6" : "col-12"}
      >
        <Paper
          key={tableIndex}
          elevation={4}
          sx={{
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          {/* 🔵 Wrap ClassicTable inside versionGroups */}
          {versionGroups.map((g) => (
            <div key={g.version} style={{ marginBottom: "20px" }}>
              {/* 🔵 Version INFO Block */}
       

              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  mb: 1,
                  color: "#0d47a1",
                  textTransform: "capitalize",
                  textAlign: "center",
                }}
              >
                Action: {g.version == 1 ? "Create" : "Update"}
              </Typography>

              <Divider sx={{ mb: 1, backgroundColor: "#000000" }} />

              <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {[
                  {
                    label: "DUCID / Serial Number",
                    value:
                      g?.DUCID  || "",
                  },
                  { label: "User", value: g.useName },
                  {
                    label: "Time",
                    value: moment(g.lastModified).format("DD-MM-YYYY HH:mm"),
                  },
                ].map((item, index) => (
                  <Typography
                    key={index}
                    variant="h6"
                    style={{ display: "flex", gap: "15px" }}
                  >
                    <span
                      style={{
                        fontWeight: "bold",
                        width: "50%",
                        textAlign: "left",
                      }}
                    >
                      {item.label}
                    </span>
                    <span style={{ width: "65%", textAlign: "left" }}>
                      : {item.value}
                    </span>
                  </Typography>
                ))}
              </div>

              <Divider sx={{ mb: 1, backgroundColor: "#000000" }} />

              {/* 🔵 TABLE for this version */}
              <div
                style={{ width: "100%", overflow: "auto", marginTop: "10px" }}
              >
                <b className="standardUnitTable">{table.tableName}</b>
                <ClassicTable>
                  <table
                    style={{ padding: "0px" }}
                    aria-label="simple table"
                    className="single-border-table"
                  >
                    {showHeader &&
                      renderCommonHeader(table?.defaultConfiguration)}

                    {showHeader && (
                      <tr>
                        {Array.from(
                          { length: MAX_COLS + 1 },
                          (_, i) =>
                            table["c" + i] != null && (
                              <td
                                className="header-border tableCss header-border-top-none common-header"
                                align="center"
                                style={{ textAlign: "center" }}
                              >
                                <b>{table["c" + i]}</b>
                              </td>
                            )
                        )}

                        {table["isUncertainty"] == 1 &&
                          !staticTables[tableIndex].isVerticalUncertainty && (
                            <td
                              className="header-border tableCss black header-border-top-none common-header"
                              align="center"
                            >
                              <b>Expanded Uncertainty (±)</b>
                            </td>
                          )}

                        {table["isComplianceStatus"] == 1 && (
                          <td
                            className="header-border tableCss black header-border-top-none common-header"
                            align="center"
                          >
                            <b>Compliance Status</b>
                          </td>
                        )}
                      </tr>
                    )}

                    {/* 🔵 Rows ONLY for this version */}
                    {renderRows(table, g.cleanedRows, g.prevRows)}
                  </table>
                </ClassicTable>
              </div>
            </div>
          ))}
        </Paper>
      </div>
    );
  });
}
